import {CTA, styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {reset as resetAnswer} from '../../store/features/answers/answerSlice';
import {set as setPage} from '../../store/features/pages/pageSlice';
import {Page} from '../../types/enums/page.enum';
import {useAppDispatch} from '../../store/hooks';
import useTrans from '../../hooks/use-trans';
import {ResultModel} from '../../types/results';
import {CTAWrapper} from '../../styles/global.style';
import {Language} from '../../types/locale';
import {useFeatureServices} from '../../use-feature-services';

interface ResultBuildInterface {
  result: ResultModel;
}

const ResultBuildContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.size.dynamic0040};
  padding: 0 ${(props) => props.theme.size.grid002};
  padding-bottom: ${(props) => props.theme.size.dynamic0100};
  flex-wrap: wrap;

  @media screen and (min-width: 480px) {
    flex-direction: row;
  }
`;

const ResultBuild: React.FC<ResultBuildInterface> = ({result}) => {
  const {tracking} = useFeatureServices();

  const trans = useTrans();
  const enTrans = useTrans('en' as Language);

  const dispatch = useAppDispatch();

  const onTryPoll = () => {
    dispatch(resetAnswer());
    dispatch(setPage(Page.POLL));

    tracking.track('VWBasic_Button_Click', {
      eventInfo: {
        contentId: 'Try Poll Again',
        brand: "passenger"
      },
      process: {
        Name: 'SUVW Questionnaire and Lead Capture Form',
        StepName: 'Results',
      },
      link: {
        url: window.location.href,
        name: enTrans.pages.results.try,
      },
    });
  };

  const handleBuildClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    tracking.track('VWBasic_Button_Click', {
      eventInfo: {
        contentId: 'Build Vehicle',
        brand: "passenger"
      },
      process: {
        Name: 'SUVW Questionnaire and Lead Capture Form',
        StepName: 'Results',
      },
      configuration: {
        CarlineName: result.carlineName,
      },
      link: {
        url: result.cta.build.url,
        name: result.cta.build.linkName,
      },
    });

    window.open(result.cta.build.url, '_self');
  };

  return (
    <ResultBuildContainer>
      <CTAWrapper>
        <CTA
          tag="button"
          emphasis={'secondary'}
          onClick={onTryPoll}
          aria-label={trans.pages.results.try}
        >
          {trans.pages.results.try}
        </CTA>
      </CTAWrapper>
      <CTAWrapper>
        <CTA
          tag="a"
          emphasis={'primary'}
          href={result.cta.build.url}
          onClick={handleBuildClick}
          aria-label={result.cta.build.title}
        >
          {result.cta.build.title}
        </CTA>
      </CTAWrapper>
    </ResultBuildContainer>
  );
};

export default ResultBuild;
